import { FC, PropsWithChildren } from 'react';
import { BaseCallout } from './base-callout';

type SelectAllCalloutProps = {
  anchorRef: React.RefObject<HTMLElement>;
  innerRef?: React.Ref<HTMLDivElement>;
  onDismiss?: () => void;
  showBanner: boolean;
};

export const SelectAllCallout: FC<PropsWithChildren<SelectAllCalloutProps>> = (props) => {
  return <BaseCallout {...props} placement='right' arrowPosition='left' />;
};
